import {
  DRIVERLINE_ALL,
  DRIVERLINE_GET,
  DRIVERLINE_DEL,
  DRIVERLINE_PUT,
  DRIVERLINE_POST,
  DRIVERLINE_LOADING,
  DRIVERLINE_ERROR,
} from '../types';

import api from '../../../utils/functions/api';

export const driverLineCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: DRIVERLINE_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/driver-line`,
      {
        ...payload,
      },
    );
    dispatch({ type: DRIVERLINE_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: DRIVERLINE_ERROR });
    throw new Error(error);
  }
};

export const driverLineAll = (params) => async (dispatch) => {
  try {
    const { name = '', size = '', page = 1 } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/driver-line?name=${name}&size=${size}&page=${page}`,
    );
    if (status === 200) {
      dispatch({ type: DRIVERLINE_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: DRIVERLINE_ERROR });
    throw new Error(error);
  }
};

export const driverLineGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/driver-line/${id}`,
    );
    if (status === 200) {
      dispatch({ type: DRIVERLINE_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: DRIVERLINE_ERROR });
    throw new Error(error);
  }
};

export const driverLinePut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: DRIVERLINE_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/driver-line/${id}`,
      payload,
    );
    dispatch({ type: DRIVERLINE_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: DRIVERLINE_ERROR });
    throw new Error(error);
  }
};
export const driverLineDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: DRIVERLINE_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/driver-line/${id}`,
    );
    dispatch({ type: DRIVERLINE_DEL, payload: data });
  } catch (error) {
    const { status } = error.request;
    console.error(error);

    if (status === 403) {
      const message = 'ไม่สามารถลบข้อมูลเนื่องจากยังคงมีข้อมูลอยู่ในหมวดหมู่';
      dispatch({ type: DRIVERLINE_ERROR, payload: { message } });
      throw new Error(message);
    } else {
      const message = 'เกิดข้อผิดพลาด';
      dispatch({ type: DRIVERLINE_ERROR, payload: { message } });
      throw new Error(message);
    }
  }
};
